var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"c-base-header-page columns is-gapless is-mobile is-vcentered has-text-centered",class:[_vm.isHorizontalStyle, _vm.backgroundColor]},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"c-base-header-page__content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }